<template>
  <transition name="el-zoom-in-top">
    <el-card class="box-card" style="text-align: left;" v-show="update.show">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>修改奖品</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="update.show=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <div v-show="show">
        <!-- 填写基础信息 -->
        <el-form
          ref="update.awardform"
          :model="update.awardform"
          label-width="120px"
          style="width:50%"
          :rules="rules"
        >
          <el-form-item label="商品名称" prop="awardStuffName">
            <el-input v-model="update.awardform.awardStuffName" style="width:50%"></el-input>
          </el-form-item>
          <el-form-item label="上传图片">
            <el-upload
              ref="upload"
              :action="uploadurl"
              :data="uploaddata"
              list-type="picture-card"
              :on-success="qinchulist"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :auto-upload="false"
              :file-list="update.fileList"
              :limit="1"
              :on-change="onchange"
              name="uploadFile"
            >
              <el-tooltip class="item" effect="dark" content="只能上传一张图片" placement="top">
                <i class="el-icon-plus"></i>
              </el-tooltip>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="图片展开" />
            </el-dialog>
          </el-form-item>
          <el-form-item label="总卷面值" prop="awardStuffTotal">
            <el-input v-model.number="update.awardform.awardStuffTotal" style="width:50%">
              <template slot="append">个</template>
            </el-input>
          </el-form-item>
          <el-form-item label="卷面值" prop="awardStuffValue">
            <el-input v-model.number="update.awardform.awardStuffValue" style="width:50%"></el-input>
          </el-form-item>
          <el-form-item label="是否置顶" prop="awardStuffIstop">
            <el-switch v-model="update.awardform.awardStuffIstop"></el-switch>
          </el-form-item>
          <el-form-item label="详细信息" prop="remark">
            <el-input type="textarea" v-model="update.awardform.remark"></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
        </el-form>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="resetForm('update.awardform')">重置</el-button>
          <el-button
            style="margin-top: 12px;"
            @click="submitadd('update.awardform')"
            type="primary"
          >提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>
<script>
import { findlistbytype } from "@/api/market/pond";
import { awardstuffVoucherupdate } from "@/api/market/marketing";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    update: {
      type: Object,
      default: () => {
        return {
          show: false,
          ifFile: false,
          row: {},
          awardform: {
            awardStuffValue: null,
            awardStuffTotal: 0,
            awardStuffName: null,
            awardStuffImageurl: null,
            awardStuffIstop: false,
            remark: null
          },
          fileList: []
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      show: true,
      active: 1,
      // 上传图片
      uploaddata: { folder: "Hirisw" },
      uploadurl:
        process.env.VUE_APP_BASE_API +
        "/mtscitech/back/fileuploader/fileupload",
      dialogImageUrl: "",
      dialogVisible: false,
      rules: {
        awardStuffName: [
          { required: true, message: "请输入奖品名称", trigger: "blur" },
          { min: 2, max: 20, message: "长度在 2 到 20 个字符", trigger: "blur" }
        ],
        awardStuffValue: [
          { required: true, message: "请输入奖品金额", trigger: "blur" },
          { type: 'number', message: '必须为数字值'}
        ],
        awardStuffTotal: [
          { required: true, message: "请输入奖品总卷面值", trigger: "blur" },
          { type: "number", message: "必须为数字值" }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          // 上传图片
          if (this.update.ifFile) {
            this.uploadurl =
              process.env.VUE_APP_BASE_API +
              "/mtscitech/back/fileuploader/fileupload";
            this.$refs.upload.submit();
          } else {
            this.update.row = this.update.awardform;
            awardstuffVoucherupdate(this.update.row).then(response => {
              if (response.status_code == 200) {
                this.$message({
                  type: "success",
                  message: "修改成功!"
                });
                this.resetForm("update.awardform");
                this.search();
                this.update.show = false;
              } else {
                this.$message({
                  type: "warning",
                  message: "修改失败!请检查字段"
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
    },
    //文件上传
    submitUpload() {},
    // upload
    handleRemove(file, fileList) {
      this.update.ifFile = false;
      this.update.awardform.awardStuffImageurl = "";
      console.log(this.update.ifFile);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onchange(file) {
      this.update.ifFile = !this.update.ifFile;
      console.log(this.update.ifFile);
    },
    qinchulist(response, file, fileList) {
      this.update.awardform.awardStuffImageurl = response.data;
      this.update.row = this.update.awardform;
      awardstuffVoucherupdate(this.update.row).then(response => {
        if (response.status_code == 200) {
          this.$message({
            type: "success",
            message: "修改成功!"
          });
          this.resetForm("update.awardform");
          this.search();
        } else {
          this.$message({
            type: "warning",
            message: "修改失败!请检查字段"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
